<template>
  <button
    class="flex w-full md:w-1/2 lg:w-1/3 items-center justify-between bg-bkk-25 px-6 py-5 rounded-lg mt-6"
  >
    <span class="text-lg">{{ t("challenges.tab.history.button.label") }} </span>
    <div
      class="w-10 h-10 rounded-full bg-white flex items-center justify-center"
    >
      <ArrowRight class="w-6 h-6" />
    </div>
  </button>
</template>

<script setup lang="ts">
import ArrowRight from "../icon/ArrowRight.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
